<script setup>
import SelectHall from "~/components/bought/select-hall.vue";
import RPreviewPlace from "~/components/bought/preview-place.vue";
import halls from "~/utils/halls";

const route = useRoute();

const hall = computed(() =>
  halls.find((hall) => {
    return hall.type == route.params.id;
  })
);

const head = computed(() => {
  return {
    title: `${hall.value?.label} | Государственный русский театр драмы им. Ф. А. Искандера`,
    meta: [
      {
        hid: "title",
        property: "title",
        content: `${hall.value?.label} | Государственный русский театр драмы им. Ф. А. Искандера`,
      },
      {
        hid: "og:title",
        property: "og:title",
        content: `${hall.value?.label} | Государственный русский театр драмы им. Ф. А. Искандера`,
      },
      {
        hid: "url",
        name: "url",
        content: `https://rusdram.org${route.fullPath}`,
      },
      {
        hid: "og:url",
        property: "og:url",
        content: `https://rusdram.org${route.fullPath}`,
      },
      {
        hid: "image",
        name: "image",
        content: "https://rusdram.org/rusdram.jpg",
      },
      {
        name: "og:image",
        property: "og:image",
        content: "https://rusdram.org/rusdram.jpg",
      },
    ],
  };
});

useHead(head);
</script>

<template>
  <nuxt-layout name="default">
    <div>
      <div class="container px-4 xl:px-0">
        <div class="flex flex-row flex-nowrap gap-x-10 relative">
          <button
            @click="$router.go(-1)"
            class="flex flex-row justify-items-center focus:outline-none"
          >
            <span class="text-light-gray text-2xl pt-1/2">
              <RIcon class="h-4 w-2" icon="angle-left" />
            </span>
            <span class="pl-4 pb-px -mt-1 text-light-gray text-xl"
              >Назад к списку</span
            >
          </button>
        </div>
      </div>
      <div v-if="hall">
        <r-section :title="hall.label" class="pt-4">
          <SelectHall
            :hall-cathegory="hall.type"
            :hall="hall.hall"
            :place="RPreviewPlace"
            :popup="null"
            :tickets="[]"
            :cart="[]"
          />
        </r-section>
      </div>
    </div>
  </nuxt-layout>
</template>
